module.exports = __webpack_public_path__ + "static/media/ASP2.be5567ef.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/ASP2.png
// module id = 877
// module chunks = 0